export default {"src":"/_next/static/image/public/images/language/pl.d75d643bb9072878a83690d8eb7d4e4a.svg","height":18,"width":18};